import { useLocation } from 'react-router';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import getAppSite from 'utils/getAppSite';
import { createIncludeRepostsOption, DateOptionsMapping } from 'components/Dashboard/Analytics/createAnalyticsState';
import { store } from 'components/Store';
import { useContext } from 'react';

const useCreateHoverText = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;

  const { analyticsState } = state;
  const { tweetsDateInterval } = analyticsState;

  const { datahub, chartWord = 'report', dashboard } = props ?? {};
  const repostsOption = () => {
    let value = createIncludeRepostsOption({ tweetsDateInterval });
    if (dashboard) {
      let sixMonthsFilter = DateOptionsMapping.find((item) => item.name === 'Last 6 months');
      value = createIncludeRepostsOption({ tweetsDateInterval: sixMonthsFilter });
    }
    return value;
  };

  const { topicOrClientWord } = useTopicOrClientWord();
  const hoverText = {
    mentions: `This ${chartWord} shows the number of mentions over time, based on the ${topicOrClientWord} applied, and broken down in various ways. ${
      datahub
        ? 'Click to see more data and apply filters'
        : 'on a point on the graph to see the data breakdown in more detail.'
    }`,
    tweets: `This ${chartWord} shows the number of X posts${repostsOption() ? ' and reposts' : ''} over time, based on the ${topicOrClientWord} applied, and broken down in various ways. ${
      datahub
        ? 'Click to see more data and apply filters'
        : 'on a point on the graph to see the data breakdown in more detail.'
    }`,
    'sentiment-snapshot': `This ${chartWord} shows the breakdown of positive, negative, neutral and mixed sentiment amongst ${
      getAppSite() === 'usa' ? 'policymakers' : 'parliamentarians'
    } in the last ${
      import.meta.env.VITE_APP_SENTIMENT_SNAPSHOT_NUM_DAYS
    } days, based on the ${topicOrClientWord} applied. ${
      datahub
        ? 'Click to see more data and apply filters'
        : 'on a point on the graph to see the data breakdown in more detail.'
    }`,
    'sentiment-changes': `This ${chartWord} shows how net sentiment has changed amongst ${
      getAppSite() === 'usa' ? 'policymakers' : 'parliamentarians'
    } over time, based on the ${topicOrClientWord} applied. ${
      datahub
        ? 'Click to see more data and apply filters'
        : 'on a point on the graph to see the data breakdown in more detail.'
    }`,
    'top-mps-and-peers': `This ${chartWord} plots the top political stakeholders by their interest and influence, based on the ${
      datahub ? 'search' : topicOrClientWord
    } applied. Hover over a stakeholder to see what makes them interested and/or influential, and click to visit their profile, including all relevant activity.`,
    'interest-by-region': `This ${chartWord} shows the number of mentions based on region of the UK. ${
      datahub
        ? 'Click to see more data and apply filters'
        : 'on a point on the graph to see the data breakdown in more detail.'
    }<br/><br/>&copy; <a class="map-attribution-link" href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a> &copy; <a class="map-attribution-link" href="https://carto.com/attributions" target="_blank" rel="noreferrer">CARTO</a>`,
  };
  return { hoverText };
};

const HoverText = (props) => {
  const { chartWord } = props ?? {};
  const location = useLocation();
  const sectionName = location.pathname.replace('/analytics/', '');
  const { hoverText } = useCreateHoverText({ chartWord });

  const isInterestByRegion = sectionName === 'interest-by-region';

  return (
    <span
      className='chart-icon-information'
      data-tooltip-html={hoverText[sectionName]}
      data-tooltip-id={isInterestByRegion ? 'tooltip-mobile-clickable' : 'tooltip-mobile'}
      data-tooltip-class-name={'header-tooltip pricing-tooltip-description'}
    >
      <span className='icon-single-info paragraph-p2' />
    </span>
  );
};

export { useCreateHoverText };
export default HoverText;
